export enum TableauErrorCode {
  InvalidToken = "INVALID_TOKEN",
  TokenNotFound = "TOKEN_NOT_FOUND",
  EntityNotFound = "ENTITY_NOT_FOUND",
  UnexpectedError = "UNEXPECTED_ERROR",
}

const ENTITY_NOT_FOUND_MSG = "You must select a University.";
const UNEXPECTED_ERROR_MSG = "We couldn't load the report right now. Please refresh the page and try again.";

const displayMessage: Record<TableauErrorCode, string> = {
  [TableauErrorCode.InvalidToken]: UNEXPECTED_ERROR_MSG,
  [TableauErrorCode.TokenNotFound]: UNEXPECTED_ERROR_MSG,
  [TableauErrorCode.EntityNotFound]: ENTITY_NOT_FOUND_MSG,
  [TableauErrorCode.UnexpectedError]: UNEXPECTED_ERROR_MSG,
};

export const getTableauErrorMessage = (code: TableauErrorCode | string) =>
  displayMessage[code] ?? UNEXPECTED_ERROR_MSG;
